import { PostEditorPostErrors, PostGroupsType } from '../../../models/post-editor';
import { ErrorMessageSeverity } from '../../../constants/form';
import { PostEditorValidationMessages } from '../constants/validation-messages';

export const pinterestBoardRequired = (
  postGroup: PostGroupsType,
  severity: ErrorMessageSeverity
): PostEditorPostErrors => {
  const { profiles } = postGroup;
  const selectedSocialProfiles = profiles.filter(
    profile => profile.__typename === 'PinterestSocialProfile' && !profile.pnBoardId
  );
  return selectedSocialProfiles.length
    ? {
        profileId: null,
        variationId: null,
        severity,
        selectedSocialProfiles,
        message: PostEditorValidationMessages.pinterestBoardRequired
      }
    : false;
};
